<template>
    <CardPanel class="mt-5">
        <template v-slot:title> {{ $t('messages.attendance') }} - {{ $t('messages.today') }} </template>

        {{ attendance.count }} {{ $t('messages.absences') }}

        <form :action="this.attendance.url" method="post" @submit.prevent="submit()">
            <div class="flex space-x-2 items-center">
                <FormSelect v-model="form.justification" :options="attendance.options.justifications" />
                <AppButton element="button" type="submit" :disabled="form.processing" desired-action class="mt-1">
                    {{ $t('messages.justify') }}
                    <span v-if="form.processing" class="ml-1 btn-spinner" />
                </AppButton>
            </div>
        </form>
    </CardPanel>
</template>

<script>
import CardPanel from '@/Shared/CardPanel.vue';
import FormSelect from '@/components/Forms/FormSelect.vue';
import AppButton from '@/components/AppButton.vue';

export default {
    name: 'StudentProfileJustifyAbsences',
    props: {
        attendance: {
            required: true,
            type: Object,
        },
    },
    components: {
        CardPanel,
        FormSelect,
        AppButton,
    },
    data() {
        return {
            form: this.$inertia.form(this.attendance.form),
        };
    },
    methods: {
        submit() {
            this.form.patch(this.attendance.url, {
                preserveState: false,
            });
        },
    },
};
</script>
